import { NICHE_LANDING_LIST } from "../Clinic/NicheLanding/nicheLandings";

/** Структура маркетингового сайта (аналог «Для кого / Возможности» у 1С, под Бай.Спорт). */

export const MARKETING_AUDIENCE = [
  {
    title: "Малый бизнес и соло",
    items: [
      {
        to: "/dlya-trenera",
        title: "Один тренер",
        text: "Журнал, абонементы и кабинет родителей",
      },
      {
        to: "/dlya-edinoborstv",
        title: "Школа единоборств",
        text: "Карате, бокс, самбо, дзюдо, ММА",
      },
      {
        to: "/dlya-tancev",
        title: "Танцевальная школа",
        text: "Хореография, балет, хип-хоп",
      },
      {
        to: "/dlya-gimnastiki",
        title: "Гимнастика и акробатика",
        text: "Группы по уровням и cheer",
      },
    ],
  },
  {
    title: "Секции и школы",
    items: [
      {
        to: "/dlya-plavaniya",
        title: "Школа плавания",
        text: "Бассейн, уровни, абонементы",
      },
      {
        to: "/dlya-futbola",
        title: "Футбольная секция",
        text: "ДЮСШ, U-команды, взносы",
      },
      {
        to: "/crm-dlya-sportivnogo-kluba",
        title: "Спортивный клуб",
        text: "Команда тренеров и CRM",
      },
      {
        to: "/zhurnal-poseshchaemosti",
        title: "Журнал посещаемости",
        text: "Перекличка с телефона",
      },
    ],
  },
  {
    title: "Продукт",
    items: [
      {
        to: "/abonementy",
        title: "Абонементы и оплаты",
        text: "Должники и эквайринг",
      },
      {
        to: "/sozdat-prilozhenie-dlya-kluba",
        title: "Приложение клуба",
        text: "PWA под вашим брендом",
      },
      {
        to: "/tarify",
        title: "Тарифы",
        text: "От старта до крупной секции",
      },
      {
        to: "/registraciya",
        title: "Попробовать",
        text: "Регистрация клуба",
      },
    ],
  },
];

export const MARKETING_FEATURES = [
  {
    to: "/vozmozhnosti#journal",
    title: "Журнал и расписание",
    text: "Отметки на занятии, группы, календарь",
  },
  {
    to: "/vozmozhnosti#memberships",
    title: "Абонементы",
    text: "Пакеты, списание, должники",
  },
  {
    to: "/vozmozhnosti#crm",
    title: "CRM и клиенты",
    text: "База учеников, воронка, чат",
  },
  {
    to: "/vozmozhnosti#app",
    title: "Кабинеты и PWA",
    text: "Родители и тренеры на телефоне",
  },
];

export const MARKETING_FOOTER_COLUMNS = [
  {
    title: "Программа",
    links: [
      { to: "/vozmozhnosti", label: "Возможности" },
      { to: "/tarify", label: "Тарифы" },
      { to: "/abonementy", label: "Абонементы" },
      { to: "/zhurnal-poseshchaemosti", label: "Журнал" },
      { to: "/sozdat-prilozhenie-dlya-kluba", label: "Приложение клуба" },
      { to: "/registraciya", label: "Попробовать" },
    ],
  },
  {
    title: "Кому подойдёт",
    links: NICHE_LANDING_LIST.map((n) => ({
      to: n.path,
      label: n.label,
    })).concat([{ to: "/dlya-trenera", label: "Для тренера" }]),
  },
  {
    title: "Компания",
    links: [
      { to: "/o-kompanii", label: "О компании" },
      { to: "/blog", label: "Блог" },
      { to: "/docs", label: "Документация" },
      { to: "/dlya-kogo", label: "Все ниши" },
    ],
  },
];

export const MARKETING_PATHS = {
  forWhom: "/dlya-kogo",
  features: "/vozmozhnosti",
  pricing: "/tarify",
  blog: "/blog",
  about: "/o-kompanii",
  buy: "/registraciya",
};
